import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  TableContainer,
  TableFooter,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
} from '@mui/material';
import { PruForm } from 'src/app/common/components/PruForm';
import { useIntl } from 'react-intl';
import ProTableCell from 'src/app/common/components/ProTable/ProTableCell';
import StickyTableCell from 'src/app/common/components/ProTable/StickyTableCell';
import PruTableLoading from 'src/app/common/components/Table/PruTableLoading';
import PruTableEmptyRow from 'src/app/common/components/Table/PruTableEmptyRow';
import PruTablePaginationActions from 'src/app/common/components/Table/PruTablePaginationActions';
import filterConfig from './filterConfig';
import tableHeader from './tableHeader';
import tableConfig from './tableConfig';
import { styles } from './styles';
import { useLang } from 'src/app/i18n';
import { regionLocale } from 'src/app/i18n';
import { getTaskList } from '../../api';
import moment from 'moment';

const EngagementTaskList: FC<any> = (props) => {
  const intl = useIntl();
  const { classes } = styles();
  const Translation = (id: string) => intl.formatMessage({ id, defaultMessage: id });
  const locale = useLang();
  const filterInitData = {};
  const { enableCreate, enableUpdate } = props;
  const [filterData, setFilterData] = useState<{ [key: string]: any }>(filterInitData);
  const [filterSavedData, setFilterSavedData] = useState<{ [key: string]: any }>(filterInitData);
  const [tableData, setTableData] = useState<{ [key: string]: any }[]>([]);
  const [pageData, setPageData] = useState<{ [key: string]: any }>({
    pageNum: 0,
    pageSize: 20,
  });
  const [formLoading, setFormLoading] = useState<boolean>(false);
  useEffect(() => {
    const fetchAPI = async () => {
      setFormLoading(true);
      await initialListData();
      await fetchData();
      setFormLoading(false);
    };
    fetchAPI();

    return;
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.addEventListener('keypress', keyPressSearch);
    return () => {
      window.removeEventListener('keypress', keyPressSearch);
    };
    // eslint-disable-next-line
  }, [filterData]);

  const initialListData = async () => {
    const allOpt: any = {};
    regionLocale.forEach((lang) => {
      allOpt[lang] = { name: 'All' };
    });
  };

  const fetchData = async (newFilterState?: any) => {
    setFormLoading(true);
    const newFilter = newFilterState || {};
    const requestParams = {
      ...filterData,
      ...pageData,
      ...newFilter,
      updatedTo: filterData?.timeRange?.[1] && moment(filterData?.timeRange?.[1]).endOf('day').toISOString(),
      updatedFrom: filterData?.timeRange?.[0] && moment(filterData?.timeRange?.[0]).startOf('day').toISOString(),
    };
    delete requestParams.total;
    delete requestParams.timeRange;
    getTaskList(requestParams)
      .then((res: any) => {
        setTableData(res?.data?.docs || []);
        setPageData({
          pageNum: res.data?.pageNum || 0,
          pageSize: res.data?.pageSize || pageData.pageSize,
          total: res.data?.total || 0,
        });
        setFormLoading(false);
      })
      .catch((err: any) => {
        console.log(err.message);
        setFormLoading(false);
      });
  };

  const onSearch = () => {
    // setFilterData(filterData)
    console.log(filterData);
    const newPageData = {
      ...pageData,
      pageNum: 0,
    };
    setPageData(newPageData);
    setFilterSavedData(filterData);
    fetchData({ ...filterData, ...newPageData });
  };

  const keyPressSearch = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const onChangePage = (pageNum: number) => {
    const newPageData = {
      ...pageData,
      pageNum,
    };
    setPageData(newPageData);

    fetchData({ ...filterSavedData, ...newPageData });
  };

  const onChangePageRows = (rows: any) => {
    const newPageData = {
      ...pageData,
      pageNum: 0,
      pageSize: rows,
    };
    setPageData(newPageData);
    fetchData({ ...filterSavedData, ...newPageData });
  };

  const handleSort = (sorter: any) => {
    let sortItem;
    let sortOrder;
    Object.entries(sorter).forEach(([item, order]) => {
      sortItem = item;
      sortOrder = order;
    });
    const data = {
      ...filterSavedData,
      sortItem,
      sortOrder: sortOrder ? (sortOrder as string).toUpperCase() : sortOrder,
    };

    const newPageData = {
      ...pageData,
      pageNum: 0,
    };

    setFilterSavedData(data);
    setPageData(newPageData);
    fetchData({ ...data, ...newPageData });
  };

  const AddTask = () => {
    // setPopUpVisible(true);
    props.history.push('/pulseleads/engagement/task/create');
  };

  const refreshData = async () => {
    const newPageData = {
      ...pageData,
      pageNum: 0,
    };
    setPageData(newPageData);
    fetchData({ ...filterSavedData, ...newPageData });
  };

  const onReset = () => {
    setFilterData(filterInitData);
  };

  return (
    <>
      <PruForm
        config={filterConfig(Translation, onSearch, onReset, locale)}
        data={filterData}
        onChange={setFilterData}
        space={20}
        style={{ padding: 20 }}
      ></PruForm>

      <PruForm
        config={tableHeader(Translation, AddTask, refreshData, enableCreate)}
        data={[]}
        onChange={() => {}}
        space={20}
        style={{ padding: '15px 20px', marginTop: 20, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}
      ></PruForm>

      <TableContainer component={Paper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {tableConfig(Translation, locale).map((item) => (
                <ProTableCell
                  key={item.prop}
                  dataIndex={item.prop}
                  sorter={item.sorter}
                  handleSort={handleSort}
                  style={{ minWidth: item.minWidth || 140 }}
                >
                  {item.title}
                </ProTableCell>
              ))}
              <StickyTableCell className={`sticky-cell`}>
                {Translation('component.formLabel.operation')}
              </StickyTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <PruTableLoading isLoading={formLoading} />
            <PruTableEmptyRow isEmpty={tableData.length === 0} />
            {tableData.length > 0 &&
              tableData.map((row) => (
                <TableRow>
                  {tableConfig(Translation, locale).map((config) => (
                    <TableCell>{config.render ? config.render(row) : row[config.prop]}</TableCell>
                  ))}
                  <StickyTableCell className={`sticky-cell`}>
                    <div className={classes.operationContainer}>
                      {enableUpdate && (
                        <Link to={`/pulseleads/engagement/task/edit/${row._id}`}>
                          <div className={`${classes.operationBtn}`} style={{ marginRight: 10 }}>
                            {Translation('app.button.edit')}
                          </div>
                        </Link>
                      )}
                    </div>
                  </StickyTableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableFooter component="div" className={`table-footer-css`}>
        <TableRow component="div">
          <TablePagination
            align="right"
            rowsPerPageOptions={[5, 10, 20, 50]}
            colSpan={12}
            component="div"
            count={pageData.total || 0}
            rowsPerPage={pageData.pageSize}
            page={pageData.pageNum || 0}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={(e, page: number) => onChangePage(page)}
            onRowsPerPageChange={(e) => onChangePageRows(e.target.value)}
            ActionsComponent={PruTablePaginationActions}
          />
        </TableRow>
      </TableFooter>
    </>
  );
};

export default EngagementTaskList;
